import * as React from "react";
import { memo } from "react";

const SvgTableware = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.395 7.928a.313.313 0 0 0 .625 0V4.646h3.376v3.282a.313.313 0 0 0 .625 0V4.333a.313.313 0 0 0-.313-.312H1.926L.582.207C.52.051.364-.043.207.02.051.082-.043.238.02.395l1.375 3.97v3.563ZM19.773.02c-.156-.063-.343.03-.375.187l-1.344 3.845h-3.75a.313.313 0 0 0-.313.312V7.96a.313.313 0 0 0 .625 0V4.646h3.376v3.282a.313.313 0 0 0 .625 0V4.396l1.375-3.97c.031-.188-.03-.344-.219-.407Z"
      fill="#000"
    />
    <path
      d="M17.055 1.708A1.04 1.04 0 0 0 16.023.676H3.958a1.04 1.04 0 0 0-1.031 1.032 1.04 1.04 0 0 0 1.031 1.031h3.938l-.781 5.157c-.031.157.094.313.25.344h.031a.304.304 0 0 0 .313-.25L8.49 2.74h2.938l.782 5.251c.03.156.156.25.312.25h.031c.157-.031.282-.187.25-.344l-.78-5.157h3.938c.625-.031 1.094-.469 1.094-1.031Zm-13.503 0c0-.22.187-.407.406-.407h12.065c.219 0 .407.188.407.407a.414.414 0 0 1-.407.406H3.958a.394.394 0 0 1-.406-.406Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgTableware);
export default Memo;
